import { jsx as e } from "@emotion/react/jsx-runtime";
import l from "prop-types";
import { useTheme as i } from "../../theme.mjs";
const p = ({ fill: o, ...r }) => {
  const t = i();
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      fill: o || t.colors.foreground,
      ...r,
      children: /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5868 12.0028L4.00444 18.5894L5.4182 20.0041L12.0009 13.4172L18.5831 20.0009L19.9972 18.5865L13.4147 12.0025L19.9983 5.41467L18.5845 4L12.0006 10.5882L5.41406 4.00015L4 5.41452L10.5868 12.0028Z"
        }
      )
    }
  );
};
p.propTypes = {
  fill: l.string
};
export {
  p as Close
};
